export default __webpack_public_path__ + "static/scores@mob_2x-e96f0bd2663a9585baf4c3c8c1456d22.webp";